// Папка студии /generate для НОВОЙ генерации.
//
// Требование владельца 2026-08-03: генерация идёт в ТУ папку, в которой её
// запустили, и переход в другую папку по ходу дела результат не уводит.
// Поэтому папку фиксирует БЭК на старте (requests.studio_folder_id), а фронту
// достаточно сообщить её в теле запроса — ровно как это уже сделано для тега
// правок (editSourceTracker) и атрибуции карточек (sourceCardTracker).
//
// Значение живёт в модуле, а не в контексте React: тело запроса собирается в
// api/client.ts, вне дерева компонентов.

interface StudioFolderState {
	/** Запрос из студии: без этого бэк не заводит папку (виджет /bots и API
	 *  генерируют вне папок). */
	studio: boolean
	/** Открытая папка. null — «Новая сессия»: бэк заведёт папку лениво. */
	folderId: string | null
}

let state: StudioFolderState = { studio: false, folderId: null }

/** Студия сообщает своё текущее состояние: вызывается при монтировании и при
 *  смене открытой работы. */
export function setStudioFolder(folderId: string | null): void {
	state = { studio: true, folderId }
}

/** Уход со студии — дальнейшие генерации (виджет /bots, чат) папок не создают. */
export function clearStudioFolder(): void {
	state = { studio: false, folderId: null }
}

export function getStudioFolder(): StudioFolderState {
	return state
}
